import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls window to top on every route change.
 * Uses behavior: "auto" (instant) so route navigations don't animate a long smooth-scroll.
 * Skips scroll for in-page hash links (e.g. /plans#compare) so they jump to the anchor naturally.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return; // let hash anchors handle their own scroll
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);
  return null;
}
